export default "__VITE_ASSET__733cc4a6__"